import { render, staticRenderFns } from "./tranches.vue?vue&type=template&id=4734cb44&scoped=true&"
import script from "./tranches.vue?vue&type=script&lang=js&"
export * from "./tranches.vue?vue&type=script&lang=js&"
import style0 from "./tranches.vue?vue&type=style&index=0&id=4734cb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4734cb44",
  null
  
)

export default component.exports